// Copyright (c) Trung Le
// Distributed under the terms of the Modified BSD License.
import { DOMWidgetModel, unpack_models } from '@jupyter-widgets/base';
import { MODULE_NAME, MODULE_VERSION } from './version';
export const INIT_PROPS = {
    theme: null,
    device_pixel_ratio: null,
    renderer: 'canvas',
    use_dirty_rect: null,
    use_coarse_pointer: null,
    pointer_size: null,
    width: 'auto',
    height: 'auto',
    locale: 'EN'
};
class BaseEChartsWidgetModel extends DOMWidgetModel {
    defaults() {
        const constructor = this.constructor;
        return {
            ...super.defaults(),
            _model_module: constructor.model_module,
            _model_module_version: constructor.model_module_version,
            _view_module: constructor.view_module,
            _view_module_version: constructor.view_module_version,
            _model_name: constructor.model_name,
            _view_name: constructor.view_name,
            option: {},
            style: {},
            ...INIT_PROPS
        };
    }
}
BaseEChartsWidgetModel.serializers = {
    ...DOMWidgetModel.serializers,
    option: { deserialize: unpack_models }
};
BaseEChartsWidgetModel.updateManager = null;
BaseEChartsWidgetModel.model_name = 'BaseEChartsModel';
BaseEChartsWidgetModel.model_module = MODULE_NAME;
BaseEChartsWidgetModel.model_module_version = MODULE_VERSION;
BaseEChartsWidgetModel.view_name = 'BaseEChartsView';
BaseEChartsWidgetModel.view_module = MODULE_NAME;
BaseEChartsWidgetModel.view_module_version = MODULE_VERSION;
export { BaseEChartsWidgetModel };
